/* W8-UI-01: a file lives in a dataset, and what the platform wrote from the documents is a
   version inside it, so the former file section resolves to the dataset list. Memory folded into
   the dataset list with it and came back as its own section (W9-UI-01): `/memory` is a page again
   and is no longer redirected. Training sets were removed from the product (W9-TR-01): a run
   writes its own examples from a dataset, so an old link to one set, under `/training-sets/<id>`
   or its `/train/<id>` alias, lands on the dataset list too rather than on a missing page. */
const MOVED_TO_DATASETS = ['/data', '/training-sets'];
const RETIRED_SET_PAGES = ['/training-sets/', '/train/'];

export default defineNuxtRouteMiddleware((to) => {
  if (MOVED_TO_DATASETS.includes(to.path) || RETIRED_SET_PAGES.some((prefix) => to.path.startsWith(prefix))) return navigateTo('/datasets', { replace: true });
  if (to.path === '/organization' || to.path.startsWith('/organization/')) return navigateTo('/org/current' + to.path.slice('/organization'.length), { replace: true });
  if (to.path === '/api-keys') return navigateTo('/org/current/keys', { replace: true });
  if (to.path === '/terms' || to.path === '/privacy') return navigateTo('/legal' + to.path, { replace: true });
});
